import { extendTheme } from "@chakra-ui/react";
import { StepsStyleConfig } from "chakra-ui-steps";

const CustomSteps = {
  ...StepsStyleConfig,
  baseStyle: (props: any) => {
    // console.log(StepsStyleConfig.baseStyle(props));
    return {
      ...StepsStyleConfig.baseStyle(props),
      // stepIconContainer: {
      //   ...StepsStyleConfig.baseStyle(props).stepIconContainer,
      //   bg: "red",
      //   sx: {
      //     width: "28px !important",
      //     height: "28px !important",
      //   },
      // },
      icon: {
        ...StepsStyleConfig.baseStyle(props).icon,
        // color: "white",
      },
    };
  },
};

// console.log("here", CustomSteps.baseStyle({}));

export const theme = {
  styles: {
    global: {
      body: {
        white: "#ffffff",
        bg: "#f7f7f6",
      },
    },
  },
  colors: {
    white: "#ffffff",
    black: "#040404",
    gray: {
      100: "rgb(230, 230, 230)",
    },
  },
  fonts: {
    body: "Montserrat, sans-serif",
    heading: "Montserrat, serif",
  },
  components: {
    Steps: CustomSteps,
    Checkbox: {
      baseStyle: {
        control: {
          borderColor: "gray.400",
        },
      },
    },
    Button: {
      // see also https://stackoverflow.com/questions/65721023/i-want-to-change-the-default-style-of-the-chakra-ui-button
      // defaultProps --> our own variant
      baseStyle: {
        fontWeight: "medium",
        fontFamily: "Poppins",
      },
      variants: {
        solid: {
          paddingTop: "2px",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
          borderBottomColor: "gray.300",
        },
        primary: {
          paddingTop: "2px",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
          bgColor: "blue.500",
          color: "white",
          borderBottomColor: "blue.700",
        },
        secondary: {
          paddingTop: "2px",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
          bgColor: "green.500",
          color: "white",
          borderBottomColor: "green.700",
        },
        danger: {
          paddingTop: "2px",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
          bgColor: "red.500",
          color: "white",
          borderBottomColor: "red.700",
        },
      },
    },
    Link: {
      baseStyle: {
        color: "blue.500",
        textDecoration: "underline",
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "extrabold",
      },
    },
  },
};

export default extendTheme(theme);
